import { Icon, ICONS } from '@nimbus-library/features/shared/resources/icons';

export enum UserAutoCompleteValueType {
  GUID = 'Guid',
  PSTN = 'Pstn',
}

export enum UserAutoCompleteCallOptionType {
  business = 'business',
  mobile = 'mobile',
  home = 'home',
  upn = 'upn',
  not_found = 'not_found',
}

export const UserAutoCompleteCallOptionTypeIconsMap: Record<UserAutoCompleteCallOptionType, Icon> = {
  [UserAutoCompleteCallOptionType.business]: ICONS.CALL_BUSINESS,
  [UserAutoCompleteCallOptionType.home]: ICONS.HOME_LIGHT,
  [UserAutoCompleteCallOptionType.mobile]: ICONS.PHONE_LIGHT,
  [UserAutoCompleteCallOptionType.upn]: ICONS.CALL_TEAMS,
  [UserAutoCompleteCallOptionType.not_found]: null,
};
